import React, { useRef } from 'react';
import { JiraIssueCreateErrorBoundary } from '@atlassian/jira-issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/main.tsx';
import { issueCreateModalEntryPoint } from './entrypoint.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const IssueCreateModalLazyAfterPaint = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-jira-issue-create" */ './index'),
	{ ssr: false },
);

export const AsyncIssueCreateModalOld = () => (
	<JiraIssueCreateErrorBoundary
		id="async.jira.issue-create-modal"
		packageName="jiraIssueCreate"
		sendToPrivacyUnsafeSplunk
	>
		<Placeholder name="issue-create-modal" fallback={<></>}>
			<IssueCreateModalLazyAfterPaint />
		</Placeholder>
	</JiraIssueCreateErrorBoundary>
);

const runtimeProps = {};
const entryPointParams = {};

const useIssueCreateModalEntrypoint = () => {
	const hasLoadedEntrypoint = useRef(false);
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		issueCreateModalEntryPoint,
		entryPointParams,
	);
	const [{ isModalOpen }] = useTriggerIssueCreateModal();

	// NOTE: this is a incremental step in properly adopting entrypoints for GIC
	// Do not copy this pattern in other places before giving #help-fe-loading proper reasoning
	// LDR: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
	if (!hasLoadedEntrypoint.current && isModalOpen) {
		entryPointActions.load();
		hasLoadedEntrypoint.current = true;
	}
	return { entryPointReferenceSubject };
};

export const AsyncIssueCreateModalNew = () => {
	const { entryPointReferenceSubject } = useIssueCreateModalEntrypoint();

	return (
		<JiraEntryPointContainer
			id="async.jira.issue-create-modal"
			packageName="jiraIssueCreate"
			placeholderName="issue-create-modal"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={runtimeProps}
		/>
	);
};

export const AsyncIssueCreateModal = componentWithFG(
	'issue-create-modal-iv-llc-unnecessary-bundles',
	AsyncIssueCreateModalNew,
	AsyncIssueCreateModalOld,
);
